import { render, staticRenderFns } from "./payfail.vue?vue&type=template&id=06c0581c&scoped=true&"
import script from "./payfail.vue?vue&type=script&lang=js&"
export * from "./payfail.vue?vue&type=script&lang=js&"
import style0 from "./payfail.vue?vue&type=style&index=0&id=06c0581c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0581c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c0581c')) {
      api.createRecord('06c0581c', component.options)
    } else {
      api.reload('06c0581c', component.options)
    }
    module.hot.accept("./payfail.vue?vue&type=template&id=06c0581c&scoped=true&", function () {
      api.rerender('06c0581c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/payfail.vue"
export default component.exports